export const STORY3_CUSTOM_EXPERT_MIN = 2;
export const STORY3_CUSTOM_EXPERT_MAX = 48;

export function normalizeStory3CustomExpert(raw: string): string | null {
  const collapsed = raw
    .replace(/[\r\n\t]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
  if (collapsed.length < STORY3_CUSTOM_EXPERT_MIN) return null;
  const trimmed =
    collapsed.length > STORY3_CUSTOM_EXPERT_MAX
      ? collapsed.slice(0, STORY3_CUSTOM_EXPERT_MAX)
      : collapsed;
  if (!/[\p{L}\p{N}]/u.test(trimmed)) return null;
  return trimmed;
}

export function isStory3CustomExpertValid(raw: string): boolean {
  return normalizeStory3CustomExpert(raw) !== null;
}
